export class GooglePlace implements google.maps.Place
{
    constructor(placeid:string)
    {
        this.placeId = placeid;
    }

    placeId:string | undefined;
}
